export enum OrderDirection {
    Ascending = "asc",
    Descending = "desc"
}

export class Search {
    regex: boolean = false;
    value: string = "";
}

export class Order {
    column: number = 0;
    dir: string = OrderDirection.Ascending;
}

export class Column {
    data: string = "";
    name: string = "";
    searchable: boolean = true;
    orderable: boolean = true;
    search: Search = new Search();
}

export class DataTableInput {
    draw: number = 0;
    start: number = 0;
    length: number = 10;
    search: Search = new Search();
    order: Order[] = [];
    columns: Column[] = [];
}

export class DataTableOutput<T> {
    draw: number = 0;
    recordsTotal: number = 0;
    recordsFiltered: number = 0;
    data: T[] = [];
    error: string = "";
}
